import PropTypes from 'prop-types';
import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { defaultMemoize } from 'reselect';
import { connect } from 'react-redux';
import { Button } from 'foundations-components/transitional/components/Button';
import { SideNav, SideNavItem } from 'foundations-components/transitional/components/SideNav';
import FormattedMessage from 'I18n/components/FormattedMessage';
import withPartials from '../lib/withPartials';
import { isApplicationHubless } from '../selectors/AuthSelector';
import { getHasMultiEmailAccess } from '../selectors/EmailsSelector';
import { compose } from 'redux';
import { push } from '../actions/HistoryActions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PROFILE = 'profile';
const NOTICATIONS = 'notifications';
const SECURITY = 'security';
const EMAILS = 'emails';
const TFA = 'tfa';
class UserPreferencesSidebar extends Component {
  renderGeneral() {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "userPreferences.general"
    });
  }
  renderHubless() {
    const {
      activeTab,
      partial
    } = this.props;
    const search = window.location.search;
    return /*#__PURE__*/_jsxs(SideNav, {
      value: activeTab,
      children: [/*#__PURE__*/_jsx(SideNavItem, {
        value: PROFILE,
        title: this.renderGeneral(),
        onClick: partial(this.props.push, {
          pathname: PROFILE,
          search
        })
      }), /*#__PURE__*/_jsx(SideNavItem, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "userPreferences.security"
        }),
        value: SECURITY,
        href: SECURITY
      })]
    });
  }
  renderWithNotifications() {
    const {
      activeTab,
      partial
    } = this.props;
    return /*#__PURE__*/_jsxs(SideNav, {
      value: activeTab,
      children: [/*#__PURE__*/_jsx(SideNavItem, {
        onClick: partial(this.props.push, PROFILE),
        title: this.renderGeneral(),
        value: PROFILE
      }), /*#__PURE__*/_jsx(SideNavItem, {
        onClick: partial(this.props.push, SECURITY),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "userPreferences.security"
        }),
        value: SECURITY
      })]
    });
  }
  renderDefault() {
    const {
      activeTab,
      partial
    } = this.props;
    return /*#__PURE__*/_jsxs(SideNav, {
      value: activeTab,
      children: [/*#__PURE__*/_jsx(Button, {
        value: PROFILE,
        use: "unstyled",
        onClick: partial(this.props.push, PROFILE),
        children: this.renderGeneral()
      }), /*#__PURE__*/_jsx(Button, {
        value: NOTICATIONS,
        use: "unstyled",
        onClick: partial(this.props.push, NOTICATIONS),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "userPreferences.notification"
        })
      }), /*#__PURE__*/_jsx(Button, {
        value: SECURITY,
        use: "unstyled",
        onClick: partial(this.props.push, SECURITY),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "userPreferences.security"
        })
      })]
    });
  }
  render() {
    const {
      hasNotificationsAccess,
      isHubless,
      hasMultiEmailAccess
    } = this.props;
    if (!hasMultiEmailAccess) {
      if (isHubless) {
        return this.renderHubless();
      }
      if (hasNotificationsAccess) {
        return this.renderWithNotifications();
      }
      return this.renderDefault();
    }
    const {
      activeTab,
      partial
    } = this.props;
    return /*#__PURE__*/_jsxs(SideNav, {
      value: activeTab,
      children: [/*#__PURE__*/_jsx(SideNavItem, {
        onClick: partial(this.props.push, PROFILE),
        title: this.renderGeneral(),
        value: PROFILE
      }), /*#__PURE__*/_jsxs(SideNavItem, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "userPreferences.security"
        }),
        defaultOpen: true,
        children: [/*#__PURE__*/_jsx(SideNavItem, {
          onClick: partial(this.props.push, EMAILS),
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "emails.title.sidebar"
          }),
          value: EMAILS
        }), /*#__PURE__*/_jsx(SideNavItem, {
          onClick: partial(this.props.push, TFA),
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "tfa.title.sidebar"
          }),
          value: TFA
        })]
      })]
    });
  }
}
UserPreferencesSidebar.propTypes = {
  activeTab: PropTypes.string.isRequired,
  hasMultiEmailAccess: PropTypes.bool,
  hasNotificationsAccess: PropTypes.bool,
  isHubless: PropTypes.bool.isRequired,
  partial: PropTypes.func.isRequired,
  push: PropTypes.func.isRequired
};
const getActiveTabIdFromPath = defaultMemoize(pathname => {
  const split = pathname.split('/');
  if (split.length > 2 || split[1] === '') {
    return 'default';
  }
  let activeTab = split[1];
  if (activeTab === 'default') {
    activeTab = PROFILE;
  }
  return activeTab;
});
const mapStateToProps = (state, {
  location
}) => {
  const hasMultiEmailAccess = getHasMultiEmailAccess(state);
  const isHubless = isApplicationHubless(state);
  const activeTab = getActiveTabIdFromPath(location.pathname);
  const hasNotificationsAccess = !isHubless;
  return {
    activeTab,
    hasNotificationsAccess,
    isHubless,
    hasMultiEmailAccess
  };
};
export default compose(withPartials, withRouter, connect(mapStateToProps, {
  push
}))(UserPreferencesSidebar);